<template>
    <section class="pricing-section side-padd" id="pricing">
        <h2 style="font-size:150%;">PICKL: A complimentary, flexible vehicle for marketing, sales & consumer insight teams.</h2>
        <div class="pricing-table">
          <div v-for="pack in picklPacks" :key="pack.id" class="plan" :class="[ pack.best_value==1 ? 'featured' : '' ]">
             <div class="extra-info" v-if="pack.best_value==1">
              <h5>Best Value</h5>
            </div>
            <div class="plan-header">
              <h3 class="plan-title">{{pack.name}}</h3>
              <div class="plan-details" v-if="pack.name=='Essential'" style="background:none;">
              <p>Everything you need to try PICKL & start gathering insights</p>
            </div>
            <div class="plan-details" v-if="pack.name=='Supreme'" style="background:none;">
              <p>PICKL power for nationwide campaigns & team collaboration </p>
            </div>
             <div class="plan-details" v-if="pack.name=='Pro'" style="background:none;">
              <p>Scale your brand, increase efficiency & engage consumers with premium features </p>
            </div>
              <div class="plan-cost">
                <small style="text-align:center;">Starts at</small><br/>
                <span class="plan-price" v-if="pack.name =='Essential'">
                  $600<small style="font-size:50%;font-weight:normal;">/mo*</small>
                </span>
                <span class="plan-price" v-if="pack.name =='Supreme'">
                  $1,550<small style="font-size:50%;font-weight:normal;">/mo*</small>
                </span>
                <span class="plan-price" v-if="pack.name =='Pro'">
                  $5600<small style="font-size:50%;font-weight:normal;">/mo*</small>
                </span>
                <span class="plan-type" >billed monthly</span>
              </div>
            </div>
            <div class="plan-select" v-if="!subscriptionDetails.current_subscription" style="margin-bottom: 20px;">
              <a  data-target="#payment-popup" href="javascript:;" data-toggle="modal" @click="checkout(pack)">get Started</a>
              <select v-model="bNumberOfPickls" class="btn-select-box" v-if="pack.name == 'Essential'">
                <!-- <option value="10">10</option>
                <option value="20">20</option> -->
                <option value="30">30 credits</option>
                <option value="75">75 credits</option>
              </select>
              <select v-model="eNumberOfPickls" class="btn-select-box" v-if="pack.name == 'Supreme'">
                <option value="100">100 credits</option>
                <option value="200">200 credits</option>
                <option value="350">350 credits</option>
              </select>
              <select v-model="pNumberOfPickls" class="btn-select-box" v-if="pack.name == 'Pro'">
                <option value="400">400 credits</option>
                <option value="600">600 credits</option>

                <option value="800">800 credits</option>
              </select>
            </div>
            <div class="plan-select" v-else>
              <a class="disabled-start-button" disabled href="javascript:;">Get Started</a>
            </div>
            <ul class="plan-features" v-if="pack.name=='Essential'">
              <li>Competitor & category insights</li>
              <li>Drive shoppers to stores & products</li>
              <li>Automated geo-located campaigns</li>
              <li>In-store product & marketing verification</li>
              <li>Quality control assurance for tasks</li>
              <li>Secure dashboard & 1st party data</li>
              <li>Monthly recurring plan with rollover credits</li>
              <li>Credits valid for 1 brand</li>
            </ul>
            <!-- <dir v-if="pack.name=='Essentials'">All <strong>Essential</strong> perks, plus:</dir> -->
            <ul class="plan-features" v-if="pack.name=='Supreme'">
              <li>All <strong>Essential</strong> perks, plus:</li>
              <li>Custom consumer insights </li>
              <li>In-store & @home PICKL compaign task options</li>
              <li>Age restricted & alcohol focused tasks</li>
              <li>Bulk task automation</li>
              <li>Task optimization program</li>
              <li>Invite colleagues to your team</li>
              <li>Free monthly visual data reports</li>
              <li>Share task credits/volume pricing with up to 2 partner brands</li>
            </ul>
            <ul class="plan-features" v-if="pack.name=='Pro'">
              <li>All <strong>Supreme</strong> perks, plus:</li>
              <li>First to new beta features</li>
              <li>Retailer & store location database expansion</li>
              <li>Consumer product discovery & purchase engagements</li>
              <li>Tailored support with designated customer success team</li>
              <li>Share task credits/volume pricing with up to 4 partner brands</li>
            </ul>
          </div>
          <!-- Plan [4] -->
          <div class="plan">
            <div class="plan-header">
              <h3 class="plan-title">Enterprise</h3>
              <div class="plan-details" style="background:none;">
                <p>Team up with global campaigns, curated features, competitive & protected categories</p>
              </div>
              <div class="plan-cost">
                <div class="plan-cost">
                  <small style="text-align:center;">Starts at</small><br/>
                  <span class="plan-price">
                    $12,000<small style="font-size:50%;font-weight:normal;">/mo*</small>
                  </span>
                  <span class="plan-type" >billed quarterly</span>
                </div>
              </div>
              <!-- <div class="plan-image">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  version="1.1"
                  id="Layer_1"
                  x="0px"
                  y="0px"
                  viewBox="0 0 512 512"
                  style="enable-background:new 0 0 512 512;"
                  xml:space="preserve"
                  width="75px"
                  height="75px"
                >
                  <path
                    d="M82.877,311.122c3.417,2.287,7.281,3.38,11.104,3.38c6.45,0,12.783-3.116,16.64-8.879  c32.317-48.292,86.34-77.123,144.511-77.123c57.999,0,111.933,28.699,144.273,76.77c6.167,9.165,18.594,11.596,27.758,5.43  c9.165-6.166,11.596-18.594,5.43-27.758c-25.839-38.406-62.885-66.745-105.219-81.905C352.762,180.298,369,148.761,369,113.5  c0-62.309-50.691-113-113-113s-113,50.691-113,113c0,35.008,16.002,66.347,41.076,87.091  c-42.996,15.104-80.599,43.786-106.698,82.786C71.235,292.557,73.697,304.979,82.877,311.122z M256,40.5c40.252,0,73,32.748,73,73  s-32.748,73-73,73s-73-32.748-73-73S215.748,40.5,256,40.5z M335.758,354.63l-29.816,21.509c-4.436,3.2-6.293,8.873-4.598,14.051  l12.007,34.802c0.507,1.55,0.702,3.064,0.637,4.508c-0.425,9.347-12.14,15.741-20.732,9.543l-29.815-21.515  c-2.218-1.6-4.829-2.4-7.44-2.4c-2.611,0-5.222,0.8-7.44,2.4l-29.815,21.515c-8.592,6.198-20.363-0.196-20.735-9.543  c-0.057-1.444,0.143-2.959,0.65-4.508l11.996-34.802c1.695-5.178-0.162-10.851-4.598-14.051l-29.816-21.509  c-9.92-7.156-4.822-24.13,7.44-24.13h36.854c5.484,0,10.344-2.111,12.038-7.289l11.388-35.027c1.895-5.789,6.966-8.684,12.038-8.684  c5.072,0,10.143,2.895,12.038,8.684l11.388,35.027c1.695,5.178,6.554,7.289,12.038,7.289h36.854  C340.58,330.5,345.678,347.474,335.758,354.63z M506.758,424.63l-29.816,21.509c-4.436,3.2-6.293,8.873-4.598,14.051l12.007,34.802  c0.507,1.55,0.702,3.064,0.637,4.508c-0.425,9.347-12.14,15.741-20.732,9.543l-29.815-21.515c-2.218-1.6-4.829-2.4-7.44-2.4  s-5.222,0.8-7.44,2.4l-29.815,21.515c-8.592,6.198-20.363-0.196-20.735-9.543c-0.057-1.444,0.143-2.959,0.65-4.508l11.996-34.802  c1.695-5.178-0.162-10.851-4.598-14.051l-29.816-21.509c-9.92-7.156-4.822-24.13,7.44-24.13h36.854  c5.484,0,10.344-2.111,12.038-7.289l11.388-35.027c1.895-5.789,6.966-8.684,12.038-8.684s10.143,2.895,12.038,8.684l11.388,35.027  c1.695,5.178,6.554,7.289,12.038,7.289h36.854C511.58,400.5,516.678,417.474,506.758,424.63z M164.758,424.63l-29.816,21.509  c-4.436,3.2-6.293,8.873-4.598,14.051l12.007,34.802c0.507,1.55,0.702,3.064,0.637,4.508c-0.425,9.347-12.14,15.741-20.732,9.543  L92.44,487.528c-2.218-1.6-4.829-2.4-7.44-2.4s-5.222,0.8-7.44,2.4l-29.815,21.515c-8.592,6.198-20.363-0.196-20.735-9.543  c-0.057-1.444,0.143-2.959,0.65-4.508l11.996-34.802c1.695-5.178-0.162-10.851-4.598-14.051L5.242,424.63  c-9.92-7.156-4.822-24.13,7.44-24.13h36.854c5.484,0,10.344-2.111,12.038-7.289l11.388-35.027c1.895-5.789,6.966-8.684,12.038-8.684  s10.143,2.895,12.038,8.684l11.388,35.027c1.695,5.178,6.554,7.289,12.038,7.289h36.854  C169.58,400.5,174.678,417.474,164.758,424.63z"
                  />
                </svg>
              </div> -->
            </div>

            <div class="plan-select" style="margin-bottom:20px;">
              <a href data-target="#demo-popup" data-toggle="modal">Contact Sales</a>

              <select  class="btn-select-box" >
                <option value="1000">1,000+ credits</option>
              </select>
            </div>
            <ul class="plan-features">
              <li>All <strong>Pro</strong> perks, plus:</li>
              <li>Team up with global campaigns</li>
              <li>1st to market features</li>
              <li>competitive & protected categories</li>
              <li>Global community expansion</li>
              <li>Loyalty drivers</li>
              <li>Brand monetization opportunities</li>
              <li>Curated features & consumer engagements</li>
              <li>Sustainability & health initiatives</li>
              <li>Share task credits/volume pricing with up to 10 partner brands</li>
            </ul>
          </div>
        </div>
        <label style="text-align:center;display:block; margin-top:40px;">*Prices displayed in USD, based on 1 or 2 month cancellation policy per individual plan and monthly billing.</label>
        <PaymentPopup :amount="totalAmount" :numberOfPickls="numberOfPickls" @paymentSuccessfull="SubscribePack" :planName="planName"/>
      </section>
</template>
<script>
import PaymentPopup from '@/components/Brand/PaymentPopup.vue'
export default {
  components: {
    PaymentPopup
  },
  props: ['subscriptionDetails'],
  data () {
    return {
      picklPacks: [],
      selectedPack: {},
      selectedPackName: '',
      bNumberOfPickls: 30,
      eNumberOfPickls: 100,
      pNumberOfPickls: 400,
      numberOfPickls: 0,
      publishableKey: process.env.VUE_APP_STRIPE_API_KEY,
      loading: false,
      lineItems: [],
      successURL: process.env.VUE_APP_URL + '/subscription/success',
      cancelURL: process.env.VUE_APP_URL + '/subscription/cancel',
      totalAmount: 0,
      planName: ''
    }
  },
  mounted () {
    this.getSubscriptionPacks()
  },

  methods: {
    getSubscriptionPacks () {
      this.$http
        .get('subscriptions/listed')
        .then(
          function (response) {
            this.picklPacks = response.body.data
          }
        )
    },
    showPicklsDropDown (pack) {
      this.selectedPackName = pack.name
    },
    checkout (pack) {
      this.selectedPack = pack
      if (this.eNumberOfPickls < 100 || this.bNumberOfPickls < 30 || this.pNumberOfPickls < 400) {
        this.$notify({ type: 'error', text: 'Invalid pickl count selected...', duration: -1 })
        return false
      }
      let amount = 0
      if (pack.name === 'Essential') {
        amount = this.bNumberOfPickls * pack.price
        this.numberOfPickls = this.bNumberOfPickls
      } else if (pack.name === 'Supreme') {
        amount = this.eNumberOfPickls * pack.price
        this.numberOfPickls = this.eNumberOfPickls
      } else if (pack.name === 'Pro') {
        amount = this.pNumberOfPickls * pack.price
        this.numberOfPickls = this.pNumberOfPickls
      }
      this.totalAmount = amount
      this.planName = pack.name
    },
    SubscribePack (token) {
      this.$store.commit('showLoading')
      if (this.eNumberOfPickls < 100 || this.bNumberOfPickls < 30 || this.pNumberOfPickls < 400) {
        this.$notify({ type: 'error', text: 'Invalid pickl count selected...', duration: -1 })
        return false
      }
      let brandId = this.$store.state.userData.brandId
      this.$http
        .post(`brands/${brandId}/subscribe-pack`, { 'token_details': token, 'pack_details': this.selectedPack, 'no_of_pickls': this.numberOfPickls })
        .then(
          function (response) {
            if (response.body.status === true) {
              this.$router.push('/brand/dashboard')
              this.$store.commit('showMessage', { message: 'Transaction<br /> Successful!' })
            } else {
              this.$notify({ type: 'error', text: response.body, duration: -1 })
              this.$store.commit('hideMessage')
            }
          },
          function (response) {
            this.$notify({ type: 'error', text: 'An error occurred while processing your transaction...', duration: -1 })
            this.$store.commit('hideMessage')
          }
        )
    }
  }

}
</script>
<style scoped>
.btn-select-box {
  width: 100%;
  border-color: #782b54;
  border-radius:5px;
  font-size: 13px;
  width: 90%;
  margin: auto;
  text-align: center;
  margin-top:10px;
}
.disabled-start-button {
  background-color: #b37499 !important;
}
</style>
